var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#0BCE88",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9984 24.3984C35.4324 24.3984 24.3984 35.4324 24.3984 48.9984C24.3984 62.5644 35.4324 73.5984 48.9984 73.5984C62.5644 73.5984 73.5984 62.5644 73.5984 48.9984C73.5984 35.4324 62.5644 24.3984 48.9984 24.3984ZM62.4444 41.4444L45.6444 58.2444C45.4104 58.4784 45.1044 58.5984 44.7984 58.5984C44.4924 58.5984 44.1864 58.4784 43.9524 58.2444L35.5524 49.8444C35.0784 49.3764 35.0784 48.6204 35.5524 48.1524C36.0204 47.6784 36.7764 47.6784 37.2444 48.1524L44.7984 55.7004L60.7524 39.7524C61.2204 39.2784 61.9764 39.2784 62.4444 39.7524C62.9184 40.2204 62.9184 40.9764 62.4444 41.4444Z",
    fill: "#0BCE88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.dffb2c09ed1128002607a81dd358a5e2.svg";
export { ForwardRef as ReactComponent };